<template>
    <p-dialog header=" " :visible.sync="visible" :showHeader="false" :closable="false" class="roundedModal login-dialog" @hide="onCancel()" :modal="true">
        <LoaderPanel :loading="loading">
            <div class="p-d-flex p-jc-end" style="width: 100%">
                <p-button class="p-button-secondary p-button-text"  @click="onCancel" icon="pi pi-times" />
            </div>
            <div class="login-modal-container p-mt-2"
                :style="themeDarkMode ? { background: '#151515 !important', borderColor: '#505050', color: '#A2A2A2'} : {}  ">
                 <div class="p-d-flex p-jc-center">
                    <Header></Header>
                </div>
                <div class="p-d-flex p-jc-center">
                    <span style="font-size: 2rem; text-align: center;">Sign in</span>
                </div>
                <div class="p-d-flex p-jc-center">
                    <form @submit.prevent="handleSubmit" class="loginForm" data-clarity-mask="true">
                        <!-- Email Field -->
                        <div class="p-field">
                            <label for="email">E-mail <span class="required">*</span></label><br />
                            <p-inputText
                              id="email"
                              v-model="email"
                              v-validate="'required|email'"
                              name="email"
                              placeholder="joe@schmoe.com"
                              class="p-inputtext-lg"
                            />
              <span v-show="errors.has('email')" class="p-error">{{
                errors.first('email')
              }}</span>
            </div>

                        <!-- Password Field -->
                        <div class="p-field"> <label for="password" >Password <span class="required">*</span></label><br />
                            
  
              <p-password
                id="password"
                v-model="password"
                v-validate="'required'"
                name="password"
                placeholder="password"
                :feedback="false"
                class="p-inputtext-lg"
              />
              <span v-show="errors.has('password')" class="p-error">{{
                errors.first('password')
              }}</span>
            </div>
            <p-inlinemessage
              class="p-field"
              v-if="error.length > 0"
              severity="error"
            > <h3>Action Forbidden</h3>
              <p>{{ error }}</p>
            </p-inlinemessage>

            <!-- Links -->
            <div class="links">
              <router-link to="forget-password" style="color: red">Forgotten your password ?</router-link>
            </div>

            <!-- Login Button -->
            <div class="p-field p-d-flex p-jc-between">
              <p-button
                label="Login"
                type="submit"
                class="p-button-lg"
              />
              <p-button
                label="Start a 14 day free trial"
                class="p-button-light p-button-lg"
                @click="onclickRegister"
              />
            </div>
                        <!-- google login -->
            <!-- Google Login matching SignUpModal UI -->
            <div class="sso-divider">
                <span>or</span>
            </div>
            <!-- Google Button with matching SignUpModal behavior -->
            <div class="p-field p-d-flex p-jc-center" style="margin-top: 1rem;">
                  <div>
                <!-- You can easily customize the text using the 'label' prop " -->
                <GoogleSsoBtn label="Sign in with Google" @click="loginWithGoogle" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </LoaderPanel>
  </p-dialog>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import config from '../../../config.js'
import { loginUser } from '../../../services/user.js'
import { trackClarityEvent, identifyUser } from '../../../utils/clarity'
import Header from '../../Header.vue'
import { Validator } from 'vee-validate'
import LoaderPanel from '../../Loader/LoaderPanel.vue'
import GoogleSsoBtn from '../../googleSsoBtn.vue'

Validator.extend('email', {
  getMessage: () => 'Please enter a valid email address',
  validate: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
})

Validator.extend('required', {
  getMessage: (field) => `The ${field} is required`,
  validate: (value) => !!value,
})

export default {
  name: 'LoginModal',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Header,
    LoaderPanel,
    GoogleSsoBtn
  },

 data() {
  return {
    count: 0,
    loading: false,
    email: '',
    password: '',
    loginError: '',
    isUnderstood: false,   // Matches SignUpModal
    requiredError: false, // Add this line
    monthly_priceId: config.Monthly_priceId,
    yearly_priceId: config.Yearly_priceId,
  }
},
  methods: {
    ...mapMutations(['SET_AUTH_MODAL', 'SET_LOGIN_MODAL']),
    loginWithGoogle() {
  //       if (!this.isUnderstood) {
  //   this.requiredError = true;
  //   return;
  // }
  // this.requiredError = false;
      // Redirect browser to backend Google OAuth entry point.
      // Backend will eventually redirect back to /#/auth/google/callback?token=...&status=...
      const base = config.USER_API
      const url = `${base}auth/google`

      // 1. Define popup size and position
  const width = 500;
  const height = 600;
  const left = (window.screen.width / 2) - (width / 2);
  const top = (window.screen.height / 2) - (height / 2);
  // 2. Open the popup
  const popup = window.open(
    url,
    'GoogleLogin',
    `width=${width},height=${height},left=${left},top=${top},status=no,location=no,menubar=no`
  );

if (!popup || popup.closed || typeof popup.closed === 'undefined') {
  // 1. Show an error to the user
  this.loginError = 'Popup blocked! Please allow popups to sign in with Google.';
}
  // 3. Listen for the token from the popup
  const handleMessage = (event) => {
    // Security check: Ensure message comes from your own domain
    if (event.origin !== window.location.origin) return;
    if (event.data.type === 'GOOGLE_AUTH_SUCCESS') {
      const { token, isNewUser } = event.data;
      
      // Save token and handle redirect
      localStorage.setItem('state', token);
      
      if (isNewUser === 'true') {
        this.$router.push({ name: 'products' });
      } else {
        location.reload(); // Refresh to log the user in
      }
      // Clean up
      window.removeEventListener('message', handleMessage);
    }
  };
  window.addEventListener('message', handleMessage);

    },
    onCancel() {
      this.SET_LOGIN_MODAL(false)
      this.$emit('toggleModal', false)
    },
    gotoHome() {
      this.$router.push({ name: 'home' })
    },
    navigateToRegister() {
      this.$router.push({ name: 'register' })
    },
    onclickRegister() {
      this.SET_AUTH_MODAL(true)
      this.onCancel()
    },
    handleSubmit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.onLogin()
        } else {
          console.log('Validation failed')
        }
      })
    },
    async onLogin() {
      this.loading = true

      try {
        const res = await loginUser(this.email, this.password)
        const token = res?.data?.accessToken
        const status = res?.data?.status
        const userId = res?.data?.userId || res?.data?.id || res?.data?.user?.id
        localStorage.setItem('state', token)
        localStorage.setItem('stripeSession', status)
        // if (status === 'active') {
        if (!token) throw Error('Invalid credentials')

        if (userId) {
          identifyUser(userId)
        }
        trackClarityEvent('user_login', { method: 'email' })

        setTimeout(() => {
          location.reload()
        })
        // const data = await

        // getUserData(token).then(d => {
        //
        // })

        // await this.$nextTick()

        // } else {
        //   setTimeout(() => {
        //     this.$router.push("/products")
        //   },0)
        // }
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.loginError = e.response.data.message
        } else {
          this.loginError = 'Entered credentials are incorrect'
        }
      }

      this.loading = false
    },
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'themeDarkMode',
      'themeSecondaryColor',
      'themeFontColor',
      'subscriptionStatus',
      'selectedPriceId',
    ]),
    error() {
      return this.loginError
    },
  },
}
</script>

<style scoped>
/* .form-container {
    max-width: 400px;
    margin: 0 auto;
    padding: 2rem;
    background: #fff9db;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-title {
    text-align: center;
    margin-bottom: 1.5rem;
} */
 .sso-divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #999;
  font-size: 13px;
  
  /* Increased top and bottom margin for more spacing */
  /* Format is: top right bottom left */
  margin: 1.5rem auto 1.5rem auto; 
  
  /* Reduced from 300px to 150px to make it exactly half the width */
  max-width: 550px;    
}
.p-error {
  color: #f44336;
  font-size: 0.875em;
}

.required {
  color: #f44336;
}

.links {
  /* text-align: center; */
  margin-bottom: 1rem;
}

.links a {
  color: #007bff;
  text-decoration: none;
}

.links a:hover {
  text-decoration: underline;
}

.forgot-password {
  color: red;
  font-size: 0.875em;
  text-align: center;
  display: inline-block;
  margin-top: 0.5rem;
}

.login-button {
  display: block;
  margin: 0 auto;
}

.register-link {
  cursor: pointer;
}
</style>
